/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

const bannerCta = `${WealthyEnv.CDN_URL}/articles/banner-cta-thumbnail.png`;

const BannerCta = ({
  bannerData,
  toggleModal,
  setToggleModal
}) => {
  return (
    <BannerCtaWrapper>
      <Thumbnail
        alt="wealthy register banner"
        src={bannerCta}
      />
      <Tagline>
        {bannerData?.tagline}
      </Tagline>
      <ContentLine>
        {bannerData?.description}
      </ContentLine>
      {
        bannerData.isClient ? (
          <Button onClick={() => setToggleModal(!toggleModal)}>
            Get Started
          </Button>
        ) : (
          <Button href={bannerData?.url}>
            {bannerData?.urlText}
          </Button>
        )
      }

    </BannerCtaWrapper>
  );
};

const BannerCtaWrapper = styled.div`
  padding: 3rem 4rem;
  border-radius: 1.2rem;
  margin-bottom: 4rem;
  background-color: ${colors.cornsilk};
  text-align: center;
`;

const Tagline = styled.h2`
  font-size: 1.8rem;
  padding: 1rem 0 1.2rem;
`;

const ContentLine = styled.p`
  font-size: 1.4rem;
  color: ${colors.textGray};
  padding-bottom: 1rem;
`;

const Thumbnail = styled.img`
  width: 100%;
  max-width: 280px;
`;

const Button = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.2rem;
  background-color: #6725f4;
  text-align: center;
  margin: 1rem auto 0;
  max-width: 280px;
  padding: 1.8rem;
  font-family: MavenPro;
  font-size: 1.4rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f9f9f9;
  border: none;

  :hover {
    cursor: pointer;
    transition: all 0.3s linear;
    transform: scale(1.03);
  }

`;

export default BannerCta;
